import React, { FC } from "react";

import Props from "./Props";
import { useStyles } from "./styles";
import Flex from "@/common/components/Flex";
import { Typography } from "@mui/material";
import AppNavLink from "@/common/components/AppNavLink";
import { ReactComponent as RadioIcon } from "@/common//icons/radio.svg";
import { ReactComponent as RadioCheckedIcon } from "@/common//icons/radio-checked.svg";
import { getRouteWithSlash } from "@/router/AppRoute";
import clsx from "clsx";

const SelectBlock: FC<Props> = (props: Props) => {
  const { route, title, description, className } = props;
  const { classes } = useStyles();

  return (
    <AppNavLink
      className={clsx(classes.root, className)}
      to={getRouteWithSlash(route)}>
      <Flex alignVertical={"center"} className={classes.wrapper}>
        <RadioIcon className={classes.radio} />
        <RadioCheckedIcon className={classes.radioChecked} />
        <Flex direction={"column"} className={classes.content}>
          <Typography className={classes.title}>{title}</Typography>
          <Typography variant={"body2"} className={classes.description}>
            {description}
          </Typography>
        </Flex>
      </Flex>
    </AppNavLink>
  );
};

export default SelectBlock;
